import { render } from "./MaxBotIntegrationModal.vue?vue&type=template&id=a17ead16"
import script from "./MaxBotIntegrationModal.vue?vue&type=script&lang=js"
export * from "./MaxBotIntegrationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__